<template>
    <button v-tooltip.bottom="themeLabel" class="p-link layout-topbar-button" :aria-label="themeLabel" @click="changeTheme">
        <i class="pi text-xl!" :class="themeIcon" />
    </button>
</template>

<script setup lang="ts">
    import { computed } from 'vue'

    import { useI18n } from 'vue-i18n'

    import { Theme } from '@/enums/common.ts'
    import { useLayout } from '@/layouts/layout'

    interface ThemeSwitcherTheme {
        name: Theme
        icon: string
    }

    // data
    const { layoutConfig, changeThemeSettings } = useLayout()
    const { t } = useI18n()

    const themes: ThemeSwitcherTheme[] = [
        {
            name: Theme.Light,
            icon: 'pi-sun'
        },
        {
            name: Theme.Dark,
            icon: 'pi-moon'
        },
        {
            name: Theme.Auto,
            icon: 'pi-desktop'
        }
    ]

    // computed
    const currentThemeIndex = computed(() => {
        const index = themes.findIndex(x => x.name === layoutConfig.theme.value)
        return index > -1 ? index : 0
    })

    const themeIcon = computed(() => themes[currentThemeIndex.value]?.icon ?? '')

    const themeLabel = computed(() => {
        if (layoutConfig.theme.value !== Theme.Auto) return t(`theme.${layoutConfig.theme.value}`)

        return `${t('theme.auto')} (${t(layoutConfig.darkTheme.value ? 'theme.dark' : 'theme.light')})`
    })

    // methods
    const changeTheme = () => {
        const nextTheme = themes[(currentThemeIndex.value + 1) % themes.length]
        if (nextTheme) changeThemeSettings(nextTheme.name)
    }
</script>
